import { BaseInput } from "shared/components/forms/BaseInput";
import { numberParser } from "shared/components/forms/BaseInput/parsers";
import { SectionCard } from "shared/app/SectionCard";
import { type Register } from "shared/hooks";
import { Show } from "shared/components";
import { useAuthContext } from "providers/Auth";

interface PlanFormProps {
  register: Register;
  headerExtra?: React.ReactNode;
  footer?: React.ReactNode;
}

export const PlanForm = (props: PlanFormProps) => {
  const { register, headerExtra, footer } = props;
  const { type } = useAuthContext();

  return (
    <SectionCard title="Plan" headerExtra={headerExtra} footer={footer}>
      <div className="divide-y divide-alpha-40">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <BaseInput
              id="sqft"
              label="Size, sq.ft"
              placeholder="240"
              parser={numberParser({ max: 10000 })}
              value={register("sqft").value ?? null}
              onChange={(val) => register("sqft").onChange(val)}
              error={register("sqft").error}
            />
          </div>
          <Show if={type.isSitesAndCommunities}>
            <div>
              <BaseInput
                id="dimensions"
                label="Dimensions"
                placeholder="16 x 66"
                value={register("dimensions").value ?? ""}
                onChange={(val) => register("dimensions").onChange(val)}
                error={register("dimensions").error}
              />
            </div>
          </Show>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <BaseInput
                id="beds"
                label="Beds"
                placeholder="1"
                parser={numberParser({ max: 10 })}
                value={register("beds").value ?? null}
                onChange={(val) => register("beds").onChange(val)}
                error={register("beds").error}
              />
            </div>
            <div>
              <BaseInput
                id="baths"
                label="Baths"
                placeholder="2"
                parser={numberParser({ max: 10 })}
                value={register("baths").value ?? null}
                onChange={(val) => register("baths").onChange(val)}
                error={register("baths").error}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionCard>
  );
};
